import template from './list.html';
import controller from './list.controller';
import './list.scss';

let floraComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: "vm"
};

export default floraComponent;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/list/list.component.js